import React, { memo } from 'react';
import { View } from 'react-native';
import { EventDetailsSection } from './EventDetailsSection';
import { DateTimeSection } from './DateTimeSection';
import { EventSettingsSection } from './EventSettingsSection';
import { PublishOptionsSection } from './PublishOptionsSection';
import { PhotoUploadSection } from '@/components';
import { CreateEventFormData, CreateEventFormErrors, PublishType } from '@/types/admin/createEvent';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';

interface EventFormSectionsProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onFieldChange: (field: keyof CreateEventFormData, value: any) => void;
  appendPhotos: (added: any[]) => void;
  onStartTimePress: (anchor?: AnchorRect) => void;
  onEndTimePress: (anchor?: AnchorRect) => void;
  onPublishTypeChange: (type: PublishType) => void;
  onPublishTimePress: (anchor?: AnchorRect) => void;
}

export const EventFormSections: React.FC<EventFormSectionsProps> = memo(({
  formData,
  errors,
  onFieldChange,
  appendPhotos,
  onStartTimePress,
  onEndTimePress,
  onPublishTypeChange,
  onPublishTimePress,
}) => {
  return (
    <View>
      <EventDetailsSection
        formData={formData}
        errors={errors}
        onFieldChange={onFieldChange}
      />

      <PhotoUploadSection
        title="Event Photos"
        subtitle="Add up to 10 photos to showcase your event (JPEG, PNG, GIF, WebP)"
        photos={formData.photos}
        onPhotosChange={(photos) => onFieldChange('photos', photos)}
        onAppendPhotos={(added) => appendPhotos(added)}
        error={errors.photos}
        maxPhotos={10}
        photoType="event"
      />

      <DateTimeSection
        formData={formData}
        errors={errors}
        onStartTimePress={onStartTimePress}
        onEndTimePress={onEndTimePress}
      />

      <EventSettingsSection
        formData={formData}
        errors={errors}
        onFieldChange={onFieldChange}
      />

      <PublishOptionsSection
        formData={formData}
        errors={errors}
        onPublishTypeChange={onPublishTypeChange}
        onPublishTimePress={onPublishTimePress}
      />
    </View>
  );
});

EventFormSections.displayName = 'EventFormSections';


